import React from 'react';
import { LFC } from '../../../../Legacy';
import { Icon } from '../../../../concepts/resources/Icon';
import { Colors } from '../../../../ui';
import { Flexer } from '../../../dashboard/elements/LayoutElements';
import { ActivityFrameAddon } from './ActivityFrameAddon';

// const RenderHerd: LFC<{ object: ActivityFrameAddon }> = ({ object }) => {

//     const { selected, interaction } = usePose(object.parentFrame);
//     const highlight = !selected && interaction?.type === 'invoke' && interaction?.hint === 'herd';
//     const color = highlight ? Colors.primaryDark : Colors.slate400

//     const area = object.layout.herd;
//     if (!area?.size()) return null;

//     return <RenderBox {...{ ...area.toCSS(), color }}>
//         <Icon style={{ position: 'relative', width: '100%', height: "100%" }} src={`deqo://icons/i8/herd`} />
//     </RenderBox>;
// };

// const RenderHideShow: LFC<{ object: ActivityFrameAddon }> = ({ object }) => {

//     const { selected, interaction } = usePose(object.parentFrame);
//     const highlight = !selected && interaction?.type === 'invoke' && interaction?.hint === 'hideShow';
//     const color = highlight ? Colors.primaryDark : Colors.slate400

//     const area = object.layout.hideShow;
//     if (!area?.size()) return null;

//     const mode = object.hidden ? 'hide' : 'show';

//     return <RenderBox {...{ ...area.toCSS(), color }}>
//         <Icon style={{ position: 'relative', width: '100%', height: "100%" }} src={`deqo://icons/i8/eye-${mode}@[1.25,1.25,0]`} />
//     </RenderBox>;
// };

// const RenderIcon: LFC<{ object: Frame, type: string }> = ({ object, type }) => {
//     const { icon } = object.layout;
//     const size = FrameLabelFontSizeAttr.get(object);
//     const style = {
//         position: 'relative' as const,
//         width: '1em',
//         height: '1em',
//     }
//     return <RenderBox {...icon.toCSS()} display="flex" alignItems="center" color={Colors.frame} fontSize={size}>
//         <Icon style={style} src={icons[type] ?? icons.default} />
//     </RenderBox>;
// };

const RenderFacade: LFC<{ object: ActivityFrameAddon }> = ({ object }) => {

    if (!object.hidden) return null;

    const area = object.layout.base;
    const style = {
        ...area.toCSS(),
    };

    return <Flexer absolute flex="row" center gap="10px" background={Colors.slate300} color={Colors.slate400} style={style}>
        <Icon size="128px" src="deqo://icons/i8/eye-hide" />
        <span style={{ fontSize: '88px' }}>Hidden By Host</span>
    </Flexer>;
};

export const ActivityFrameAddonVisual: LFC<{ object: ActivityFrameAddon }> = ({ object }) => {
    return <>
        {/* <RenderMenu object={object} /> */}
        <RenderFacade object={object} />
    </>;
};
